import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { HtmlParseService } from '@commons/html-parser/html-parse.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['../job.component.scss'], // tslint:disable-line relative-url-prefix
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilComponent implements OnInit {
  @Input() profil: string;
  cleanProfil: string;

  constructor(private readonly htmlParser: HtmlParseService) {}

  ngOnInit() {
    this.cleanProfil = this.htmlParser.parse(this.profil);
  }
}
